import React from 'react'
import "./IntegralDetail.less";
import { appMethod as app } from '@utils/app';
import { Toast } from 'antd-mobile';

export default class IntegralDetail extends React.Component {
  state = {
    tabStatus: '1',
    list: [],
    isMore: '',
    currentPage: 1,
  }
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    if (app.isLogin()) {
      this.getMessageData('1');
    }else{
      app.turnToPage('login-pc');
    }
  }
  cancel= () => {
    this.props.cancelDialog('integralDialog');
  }
  getMessageData = (type,page) => {
    app.showLoading({
      title: '加载中..',
    })
    let that = this
    let action = ''
    if (type == '1') {
      action = 'add'
    } else if (type = '2') {
      action = 'minus'
    }
    app.sendRequest({
      url: '/index.php?r=AppShop/UserIntegralAction',
      data: {
        action: action,
        page: page || 1,
        page_size: 4
      },
      success: function (res) {
        app.hideLoading();
        that.setState({
          list: res.data,
          isMore: res.is_more,
          currentPage: res.current_page || '1',
        })
      }
    })
  }
  checkTap = event => {
    let type = event.currentTarget.dataset.type;
    this.setState({
      tabStatus: type,
      list: [],
    })
    this.getMessageData(type);
  }
  nextPage = () => {
    if(this.state.isMore != 1){
      Toast.info('已经是最后一页了')
      return
    }
    let page = this.state.currentPage + 1;
    this.getMessageData(this.state.tabStatus,page);
    
  }
  prePage = () => {
    if(this.state.currentPage == 1){
      Toast.info('已经是第一页了')
      return
    }
    let page = this.state.currentPage > 2 ? this.state.currentPage - 1:1
    this.getMessageData(this.state.tabStatus,page);
  }
  render() {
    return (
      <div className='integraLDialog'>
        <div className='mask' onClick={this.cancel}></div>
        <div className='content'>
          <label className='ico-moon icon-closes closes_btn' onClick={this.cancel}></label>
          <div className='title_line'>
            <div className={this.state.tabStatus=='1'?'active':''} onClick={this.checkTap} data-type='1'>收入</div>
            <div className={this.state.tabStatus=='2'?'active':''} onClick={this.checkTap} data-type='2'>支出</div>
          </div>
          <div className='main'>
            {this.state.list.map((item,index) => 
            <div className='inteItem' key={index}>
              <div>
                <div className='name'>{item.content}</div>
                <div className='time'>{item.time}</div>
              </div>
              <div className='integral_num'>{item.num}</div>
            </div>
            )}
            {this.state.list.length == 0 && 
              <div className='no_data'>
                <img src="https://cdn.jisuapp.cn/static/webapp/images/chatgpt/undata.png" />
                <div>暂无数据~</div>
              </div>
            }
          </div>
          {this.state.list.length != 0 && 
             <div className='btn_box'>
              <label className='ico-moon icon-leftarrow' onClick={this.prePage}></label>
              <div className='btn_page'>{this.state.currentPage}</div>
              <label className='ico-moon icon-rightarrow' onClick={this.nextPage}></label>
            </div>
          }
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/chatgpt-page/component/IntegralDetail/IntegralDetail.jsx